export enum BadgeType {
  Default = 'secondary',
  Success = 'success',
  Info = 'info',
  Warning = 'warn',
  Danger = 'danger',
  White = 'contrast',
}
